import { useState, useCallback, useMemo } from "react";
import { type TransportationInputsProps, type ComponentHash } from "./type";

export const useTransportationInputs = (
  componentHash: ComponentHash,
): TransportationInputsProps => {
  const [checked, setChecked] = useState(componentHash.checked);
  const [inputValues, setInputValues] = useState({
    transportationProvisionPaymentAmountMax: "",
    transportationProvisionPaymentConditions: "",
    ...componentHash.inputValues,
  });

  const parentCheckboxId = `work_requirement_welfares_${componentHash.value}`;

  // フォームの値をリセットする関数
  const clearFormValues = useCallback(() => {
    setInputValues({
      transportationProvisionPaymentAmountMax: "",
      transportationProvisionPaymentConditions: "",
    });
  }, []);

  // チェックボックスの変更をハンドルする関数
  const handleChangeCheckbox = useCallback(
    (newValue: boolean) => {
      if (!newValue) {
        const hasInput =
          inputValues.transportationProvisionPaymentAmountMax !== "" ||
          inputValues.transportationProvisionPaymentConditions !== "" ||
          inputValues.transportationProvisionFullPaymentFlag !== undefined;
        if (hasInput) {
          const userConfirmed = window.confirm(
            "チェックを外すと入力内容がリセットされます。本当にチェックを外しますか？",
          );
          if (!userConfirmed) {
            return;
          }
        }
        clearFormValues();
      }
      setChecked(newValue);
    },
    [clearFormValues, inputValues],
  );

  // 入力値の変更をハンドルする関数
  const handleInputChange = useCallback((field: string, value: string | boolean) => {
    setInputValues((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }, []);

  const transportationInputsData = useMemo<TransportationInputsProps>(() => {
    const { name, ...restComponentHash } = componentHash;

    return {
      ...restComponentHash,
      text: name,
      handleChangeCheckbox,
      handleInputChange,
      checked,
      inputValues,
      parentCheckboxId,
    };
  }, [
    componentHash,
    handleChangeCheckbox,
    handleInputChange,
    checked,
    inputValues,
    parentCheckboxId,
  ]);

  return transportationInputsData;
};
